import api from "./api";
import TokenService from "./token.service";

const register = (username, email, password) => {
    return api.post("/auth/register", {
        username,
        email,
        password
    });
};

const login = (username, password) => {
    return api
        .post("/auth/authenticate", {
            username,
            password
        })
        .then((response) => {
            if (response.data.access_token) {
                TokenService.setUser(response.data);
            }
            return response.data;
        });
};

const logout = () => {
    TokenService.removeUser();
};

const getCurrentUser = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return null;
        return JSON.parse(userStr);
    } catch (error) {
        return null;
    }
};

const check = async () => {
    try {
        const response = await api.get("/health/");
        return response.data;
    } catch (error) {
        const originalConfig = error.config;

        if (error.response) {
            if (error.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                TokenService.removeUser();
                window.location.href = '/sing-in';
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
};

const AuthService = {
    register,
    login,
    logout,
    getCurrentUser,
    check
};

export default AuthService;
